/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import React, { useState, useRef, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
// @mui material components
import {
  Card,
  Snackbar,
  Alert,
  TextField,
  InputAdornment,
  IconButton,
  Backdrop,
  CircularProgress,
  Grid,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";
import { API_ROUTES } from "utils/constants";
import { axiosInstance } from "../../../axios";
import Icon from "@mui/material/Icon";
// Images
import bgImage from "assets/images/bg-reset-cover.jpg";
import { useNavigate } from "react-router-dom";

function ConfirmPassword() {
  const { uidb64, token } = useParams(); // Lấy giá trị từ tham số động url

  const [errors, setErrors] = useState({
    password: "",
    repassword: "",
    expired: "",
  });

  const navigate = useNavigate();
  const formRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(false);
  const passwordRef = useRef("");
  const repasswordRef = useRef("");
  const [values, setValues] = useState({
    showPass: false,
  });
  const [revalues, setReValues] = useState({
    showPass: false,
  });
  const [alert, setAlert] = useState({
    alert: false,
    message: null,
    type: null,
  });
  const handlePassVisibilty = () => {
    setValues({
      ...values,
      showPass: !values.showPass,
    });
  };
  const handleRePassVisibilty = () => {
    setReValues({
      ...revalues,
      showPass: !revalues.showPass,
    });
  };
  async function onSubmitForm(event) {
    event.preventDefault();
    const _data = {};
    _data["password"] = passwordRef.current.value;
    _data["repassword"] = repasswordRef.current.value;
    _data["username"] = uidb64;
    _data["token"] = token;
    try {
      const response = await axiosInstance.post("check_expired_token", _data);
      const req = response.data;
      if (req.status == "EXPIRED") {
        setDisable(true);
        setErrors({ ...errors, expired: req.message });
        return;
      } else {
        setErrors({});
        setDisable(false);
      }
    } catch (error) {
      if (error.response && error.response.status === 500) {
        setAlert({
          alert: true,
          message: "Đã xảy ra lỗi 500. Vui lòng thử lại sau.",
          type: "error",
        });
      } else {
        console.log(error.response);
      }
      return;
    }
    const newValidationErrors = validateOBJ(_data);
    let _tempValid = newValidationErrors;

    if (Object.values(_tempValid).some((error) => error)) {
      setErrors(newValidationErrors);
      return;
    }
    if (checkconfirmpassword(_data["password"], _data["repassword"])) {
      setErrors({
        ...errors,
        repassword: "Mật khẩu không khớp",
      });
      return;
    }
    setLoading(true);
    try {
      const response = await axiosInstance.post(
        "password_reset_confirm",
        _data
      );
      setLoading(false);
      setAlert({
        alert: true,
        message: "Xác nhận thay đổi mật khẩu thành công!",
        type: "success",
      });
      const timer = setTimeout(() => {
        navigate("/sign-in"); // Chuyển hướng tới trang chủ sau khi tắt thông báo
      }, 3000); // Thời gian hiển thị thông báo (3000ms = 3 giây)
    } catch (error) {
      const ms = error.response.data;
      setAlert({ alert: true, message: ms.error, type: "warning" });
      console.log(error);
      setLoading(false);
      return;
    }
  }
  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({ alert: false, message: null, type: null });
  };
  return (
    <CoverLayout coverHeight="50vh" image={bgImage}>
      {alert.alert && (
        <Snackbar
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={alert.alert}
          onClose={handleCloseAlert}
        >
          <Alert onClose={handleCloseAlert} severity={alert.type}>
            {alert.message}
          </Alert>
        </Snackbar>
      )}
      {loading && (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
          <MDBox
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress color="info" />
          </MDBox>
        </Backdrop>
      )}
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          py={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h3" fontWeight="medium" color="white" mt={1}>
            Comfirm Password
          </MDTypography>
        </MDBox>
        <MDBox pb={3} px={3} pt={2}>
          {errors && errors.expired ? (
            <Grid container sx={{ textAlign: "center", mb: 0 }}>
              <Grid item xs={12}>
                <Alert severity="error" sx={{ mb: 3, mt: 0 }}>
                  {errors.expired}
                </Alert>
              </Grid>
            </Grid>
          ) : (
            ""
          )}
          <MDBox component="form" role="form">
            <MDBox mb={4}>
              <TextField
                fullWidth
                required
                type={values.showPass ? "text" : "password"}
                name="password"
                label="Mật khẩu"
                inputRef={passwordRef}
                error={errors ? !!errors.password : false}
                helperText={errors?.password}
                onFocus={() => {
                  setErrors({
                    ...errors,
                    password: "",
                  });
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={handlePassVisibilty}
                        aria-label="toggle password"
                        edge="end"
                      >
                        {values.showPass ? (
                          <VisibilityOffIcon />
                        ) : (
                          <VisibilityIcon />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </MDBox>
            <MDBox mb={4}>
              <TextField
                fullWidth
                required
                type={revalues.showPass ? "text" : "password"}
                name="repassword"
                label="Xác nhận mật khẩu"
                inputRef={repasswordRef}
                error={errors ? !!errors.repassword : false}
                helperText={errors?.repassword}
                onFocus={() => {
                  setErrors({
                    ...errors,
                    repassword: "",
                  });
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={handleRePassVisibilty}
                        aria-label="toggle password"
                        edge="end"
                      >
                        {revalues.showPass ? (
                          <VisibilityOffIcon />
                        ) : (
                          <VisibilityIcon />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton
                type="submit"
                onClick={onSubmitForm}
                variant="gradient"
                color="info"
                fullWidth
                disabled={disable ? true : false}
                startIcon={<CheckCircleIcon />}
              >
                Xác nhận
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </CoverLayout>
  );
}

const validateRequired = (value) => !!value.length;

function validateOBJ(user) {
  return {
    password: !validateRequired(user.password)
      ? "Mật khẩu không được trống"
      : "",
    repassword: !validateRequired(user.repassword)
      ? "Xác nhận mật khẩu không được trống"
      : "",
  };
}

const checkconfirmpassword = (value, value1) => {
  let valid = false;
  if (value !== value1) {
    valid = true;
  }
  return valid;
};

export default ConfirmPassword;
